/**
 * @generated SignedSource<<cc9585a3baa678643bb1bfd95eb76025>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type MemberGroupKind = "custom" | "default" | "role" | "test_user" | "%future added value";
export type MemberGroupRole = "admin" | "instructor" | "manager" | "owner" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type MemberGroupTagFragment$data = {
  readonly color: string;
  readonly id: string;
  readonly isSystem: boolean;
  readonly kind: MemberGroupKind;
  readonly name: string;
  readonly product: {
    readonly id: string;
    readonly name: string;
  } | null;
  readonly role: MemberGroupRole | null;
  readonly " $fragmentType": "MemberGroupTagFragment";
};
export type MemberGroupTagFragment$key = {
  readonly " $data"?: MemberGroupTagFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"MemberGroupTagFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MemberGroupTagFragment",
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "kind",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "color",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "role",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isSystem",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Product",
      "kind": "LinkedField",
      "name": "product",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "MemberGroup",
  "abstractKey": null
};
})();

(node as any).hash = "065d943e5981ddd4d55263714e4da692";

export default node;
